import { message } from 'antd';
import { put, takeLatest, select } from 'redux-saga/effects';
import { PhaseEntityType, extractParts } from 'data/projects/phase-entity';
import { logger } from 'services';
import { getAutoCorrections } from 'utils/date-shift';
import { getPhaseList, getSprintList, getTaskList, getTemplatePhaseUpdates, getTemplateTaskUpdates } from 'utils/template-date-shift';
import { updateProjectTemplateParentOfTask } from '../..';
import { rearrangeEntitiesInProjectTemplate } from '../../actions';
import { selectAllTemplateProjectPhase, selectAllTemplateSprint, selectAllTemplateTask, selectTemplateEntity, selectTemplateTask } from '../../selectors';
import { makeDateShiftsForProjectPhases, makeDateShiftsForTasks, updateProjectPhaseTemplateEntityOrder } from '../../slices';
function* rearrangeTaskInTemplateSaga(action) {
    try {
        const { payload: actions } = action;
        for(let i = 0; i < actions.length; i += 1){
            const { entityId, parent, insertAt } = actions[i];
            const { id, entityType } = extractParts(entityId);
            const entity = yield select(selectTemplateEntity(entityId));
            yield put(updateProjectPhaseTemplateEntityOrder({
                entity,
                entityId,
                ...parent,
                insertAt
            }));
            if (entityType === PhaseEntityType.Task) {
                const task = yield select(selectTemplateTask(id));
                yield put(updateProjectTemplateParentOfTask({
                    task,
                    ...parent,
                    insertAt
                }));
            }
        }
    } catch (error) {
        logger.error('rearrangeTask failed', {
            error
        });
        message.error('There was an error in rearranging the task');
    }
}
function* dateShiftOnTasksRearrangeSaga(action) {
    try {
        const { payload: actions } = action;
        let phases = yield select(selectAllTemplateProjectPhase());
        let tasks = yield select(selectAllTemplateTask());
        // TODO: need to refactor to handle sprints rearrange
        const sprints = yield select(selectAllTemplateSprint());
        for(let i = 0; i < actions.length; i += 1){
            const { entityId, parent } = actions[i];
            const { id: taskId, entityType } = extractParts(entityId);
            if (entityType === PhaseEntityType.Task) {
                var _task_parentTask, _task_projectPhase;
                /**
         * Update parent and child references
         */ const task = tasks[taskId];
                const { projectPhase: newParentPhase = {}, parentTask: newParentTask = {} } = {
                    ...parent
                };
                /**
         * Remove task reference from current parent
         */ if (task === null || task === void 0 ? void 0 : (_task_parentTask = task.parentTask) === null || _task_parentTask === void 0 ? void 0 : _task_parentTask.taskId) {
                    const currentParentTask = tasks[task.parentTask.taskId];
                    tasks = {
                        ...tasks,
                        [task.parentTask.taskId]: {
                            ...currentParentTask,
                            subTasks: currentParentTask.subTasks.filter((subTaskRef)=>subTaskRef !== taskId)
                        }
                    };
                } else if (task === null || task === void 0 ? void 0 : (_task_projectPhase = task.projectPhase) === null || _task_projectPhase === void 0 ? void 0 : _task_projectPhase.projectPhaseId) {
                    const currentProjectPhase = phases[task.projectPhase.projectPhaseId];
                    phases = {
                        ...phases,
                        [task.projectPhase.projectPhaseId]: {
                            ...currentProjectPhase,
                            tasks: currentProjectPhase.tasks.filter((taskRef)=>taskRef !== taskId)
                        }
                    };
                }
                /**
         * Add task reference in new parent and update parent reference in task
         */ if (newParentPhase === null || newParentPhase === void 0 ? void 0 : newParentPhase.projectPhaseId) {
                    const _phase = phases[newParentPhase.projectPhaseId];
                    phases = {
                        ...phases,
                        [newParentPhase.projectPhaseId]: {
                            ..._phase,
                            tasks: [
                                taskId,
                                ..._phase.tasks
                            ]
                        }
                    };
                    tasks = {
                        ...tasks,
                        [taskId]: {
                            ...task,
                            projectPhase: _phase,
                            parentTask: undefined
                        }
                    };
                } else if (newParentTask === null || newParentTask === void 0 ? void 0 : newParentTask.taskId) {
                    const _task = tasks[newParentTask.taskId];
                    tasks = {
                        ...tasks,
                        [newParentTask.taskId]: {
                            ..._task,
                            subTasks: [
                                taskId,
                                ..._task.subTasks
                            ]
                        },
                        [taskId]: {
                            ...task,
                            parentTask: _task,
                            projectPhase: undefined
                        }
                    };
                }
            }
            const taskList = getTaskList(Object.values(tasks));
            const [phaseUpdates, taskUpdates] = getAutoCorrections(getPhaseList(Object.values(phases)), taskList, getSprintList(Object.values(sprints)), {
                allowWeekend: true,
                enabledNewDependencies: false
            });
            yield put(makeDateShiftsForProjectPhases(getTemplatePhaseUpdates(phaseUpdates)));
            yield put(makeDateShiftsForTasks(getTemplateTaskUpdates(taskUpdates, taskList)));
        }
    } catch (error) {
        logger.error('Date shifting during rearrangeTask failed', {
            error
        });
        message.error('There was an error in rearranging the task');
    }
}
export function* watchRearrangeTaskInProjectTemplateSaga() {
    yield takeLatest(rearrangeEntitiesInProjectTemplate.type, rearrangeTaskInTemplateSaga);
    yield takeLatest(rearrangeEntitiesInProjectTemplate.type, dateShiftOnTasksRearrangeSaga);
}
